import { __awaiter } from "tslib";
import Vue from 'vue';
import selectHandlersMixin from './_selectHandlersMixin';
import draggable from 'vuedraggable';
import Swiper from '@/components/global/Swiper/Swiper.vue';
import swiperSlide from '@/components/global/Swiper/SwiperSlide';
import mobPositionsTableDetailItem from './daughterComponents/_mobPositionsTableDetailItem';
import { mapGetters } from 'vuex';
import { ItemClosingStatusEnum, ItemCloseRecordSource } from '@/store/modules/mainPageModules/utils/itemClose';
import _ from 'lodash';
var TransferSides;
(function (TransferSides) {
    TransferSides["long"] = "\u041B\u043E\u043D\u0433";
    TransferSides["short"] = "\u0428\u043E\u0440\u0442";
})(TransferSides || (TransferSides = {}));
let tableHeadItems = [
    {
        id: 1,
        switched: true,
        text: 'mainPage.tables.tableHeaders.ticker',
        align: 'start',
        sortable: true,
        value: 'ticker',
        width: 120,
        priority: 1
    },
    {
        id: 2,
        switched: true,
        text: 'mainPage.tables.tableHeaders.positionPrice',
        align: 'end',
        sortable: true,
        value: 'positionPrice',
        width: 120,
        priority: 2
    },
    {
        id: 3,
        switched: true,
        text: 'mainPage.tables.tableHeaders.volume',
        align: 'end',
        sortable: true,
        value: 'volume',
        width: 112,
        priority: 2
    },
    {
        id: 4,
        switched: true,
        text: 'mainPage.tables.tableHeaders.currentPrice',
        align: 'end',
        sortable: true,
        value: 'currentPrice',
        width: 120,
        priority: 3
    },
    {
        id: 5,
        switched: true,
        text: 'mainPage.tables.tableHeaders.result',
        align: 'end',
        sortable: true,
        value: 'result',
        width: 120,
        priority: 1
    },
    {
        id: 6,
        switched: true,
        text: 'mainPage.tables.tableHeaders.direction',
        align: 'start',
        sortable: true,
        value: 'direction',
        width: 80,
        priority: 3
    },
    {
        id: 8,
        switched: true,
        text: 'mainPage.tables.tableHeaders.actions',
        align: 'center',
        sortable: true,
        value: 'actions',
        width: 28,
        priority: 1
    }
];
export default Vue.extend({
    props: {
        isMain: {
            type: Boolean,
            required: true,
            default: false
        },
        tablesIsResizing: {
            type: Boolean
        }
    },
    data: () => ({
        showTooltip: false,
        letCloseTooltip: false,
        toolTipTimeoutID: null,
        shouldCloseTooltip: false,
        headerIsDragging: false,
        dragOptions: {
            animation: 200,
            group: 'description',
            disabled: false,
            ghostClass: 'ghost'
        },
        showMenu: false,
        secondaryContextMenu: false,
        headersBuffer: tableHeadItems,
        menuItems: tableHeadItems,
        menuPositionX: 0,
        menuPositionY: 0,
        sorting: '',
        isDescSort: false,
        scrolledDown: false,
        closeAwait: false,
        loadError: false,
        isRetry: false,
        mobTableTypes: ['mainPage.tables.common.brief', 'mainPage.tables.common.detailed'],
        mobTableType: 0,
        ww: 0,
        activeSlideDetailsIndex: 0,
        detailsSliderHasInited: false
    }),
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        getFuturesSettings: 'getFuturesSettings',
        getPositionsTable: 'getPositionsTable',
        getLiquidationProgress: 'getLiquidationProgress'
    })), { headersByPriority() {
            const vm = this;
            let currPriority = 3;
            if (vm.$root.windowWidth <= 768 && vm.$root.windowWidth >= 516)
                currPriority = 2;
            if (vm.$root.windowWidth < 516)
                currPriority = 1;
            return vm.headersBuffer.reduce((acc, curr) => {
                if (curr.priority <= currPriority) {
                    if (currPriority === 1) {
                        if (curr.width === 148)
                            curr.width = 130;
                        if (curr.width === 28)
                            curr.width = 37;
                    }
                    else if (currPriority === 2) {
                        if (curr.width === 148)
                            curr.width = 120;
                        if (curr.width === 112)
                            curr.width = 84;
                        if (curr.width === 28)
                            curr.width = 44;
                    }
                    acc.push(curr);
                }
                return acc;
            }, []);
        },
        progressBarTranslateValue() {
            const vm = this;
            const ratio = vm.getLiquidationProgress;
            if (ratio) {
                if (ratio === 100)
                    return 'translateX(-100%)';
                if (ratio <= 4)
                    return `translateX(${ratio * 10 * -1}%)`;
                if (ratio >= 95)
                    return `translateX(${(100 - ((100 - ratio) * 10)) * -1}%)`;
                return 'translateX(-50%)';
            }
            else
                return 'translateX(0%)';
        },
        selectedItems() {
            return this.getPositionsTable.items.filter((item) => item.selected);
        } }),
    watch: {
        mobTableType(v) {
            if (!v) {
                this.detailsSliderHasInited = false;
            }
        },
        headerIsDragging(v) {
            // const vm = this as any
            // if (!v && vm.bufferedItems.length) {
            //   vm.getPositionsTable.items = []
            //   vm.bufferedItems.forEach(item => {
            //     vm.items.push(item)
            //   })
            // }
        },
        headersBuffer(v) {
            localStorage.setItem('mainPagePositionsHeaders', JSON.stringify(v));
        },
        menuItems: {
            handler(list) {
                const vm = this;
                list.forEach((item, index) => {
                    const currentItemIndex = vm.headersBuffer.findIndex((el) => item.id === el.id);
                    if (item.switched && currentItemIndex < 0) {
                        const actionsItemIndex = vm.headersBuffer.findIndex((item) => item.value === 'actions');
                        if (index <= actionsItemIndex) {
                            vm.headersBuffer.splice(index, 0, item);
                        }
                        else {
                            vm.headersBuffer.splice(actionsItemIndex - 1, 0, item);
                        }
                    }
                    if (!item.switched && currentItemIndex >= 0) {
                        vm.headersBuffer.splice(currentItemIndex, 1);
                    }
                });
            },
            deep: true
        }
    },
    methods: {
        handleChangeScrollPosition(v) {
            this.scrolledDown = v > 0.9;
        },
        handleTheadItem(item) {
            if (this.sorting !== item.value) {
                if (item.text) {
                    this.sorting = item.value;
                }
                this.isDescSort = false;
            }
            else {
                if (!this.isDescSort) {
                    this.isDescSort = true;
                }
                else {
                    this.sorting = '';
                    this.isDescSort = false;
                }
            }
        },
        moveHandler(evt) {
            return evt.to.classList.contains('positions');
        },
        showContextMenu(evt) {
            this.secondaryContextMenu = false;
            this.showMenu = false;
            this.menuPositionX = evt.clientX;
            this.menuPositionY = evt.clientY;
            this.$nextTick(() => {
                this.showMenu = true;
            });
        },
        closeAllPositions() {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function* () {
                this.closeAwait = true;
                const positionsToClose = this.getPositionsTable.items.map((item) => {
                    const volume = item.direction === TransferSides.short ? item.volume.multipliedBy(-1) : item.volume;
                    return {
                        ticker: item.ticker,
                        amount: volume.toString()
                    };
                });
                const response = yield this.services.v2.trade.closeAllPositions(positionsToClose);
                const requested = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.requested;
                const extra = (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.extra;
                if (_.isArray(extra) && _.isArray(requested)) {
                    if (extra.length > 0) {
                        this.$store.dispatch('mainPageModules/reloadByError', { cause: 'extra при закрытии всех позиций' });
                    }
                    else {
                        requested.forEach((item) => {
                            if (item.status === ItemClosingStatusEnum.unhandledError) {
                                return;
                            }
                            this.$store.dispatch('mainPageModules/setPositionClose', { by: ItemCloseRecordSource.wl, ticker: item.ticker });
                        });
                    }
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: 'Успешно',
                        type: 'success',
                        autoDelete: true,
                        content: this.$t('mainPage.alerts.content.allPositionClosed')
                    });
                }
                else {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('mainPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('mainPage.alerts.content.operationNotExecuted')
                    });
                }
                this.closeAwait = false;
            });
        },
        closePosition(item) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                item.closing = true;
                const volume = item.direction === TransferSides.short ? item.volume.multipliedBy(-1) : item.volume;
                const response = yield this.services.v2.trade.closePosition({
                    ticker: item.ticker,
                    amount: volume.toString()
                });
                const status = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.status;
                switch (status) {
                    case ItemClosingStatusEnum.closed: {
                        this.$store.dispatch('mainPageModules/setPositionClose', { by: ItemCloseRecordSource.wl, ticker: item.ticker });
                        this.$store.dispatch('alertsBus/openAlert', {
                            title: this.$t('mainPage.alerts.titles.success'),
                            type: 'success',
                            autoDelete: true,
                            content: this.$t('mainPage.alerts.content.positionClosed', { ticker: item.ticker })
                        });
                        break;
                    }
                    case ItemClosingStatusEnum.alreadyClosed: {
                        this.$store.dispatch('mainPageModules/setPositionClose', { by: ItemCloseRecordSource.wl, ticker: item.ticker });
                        break;
                    }
                    default: {
                        this.$store.dispatch('alertsBus/openAlert', {
                            title: this.$t('mainPage.alerts.titles.error'),
                            type: 'error',
                            autoDelete: true,
                            content: this.$t('mainPage.alerts.content.operationNotExecuted')
                        });
                    }
                }
                item.closing = false;
            });
        }
    },
    mounted() {
        const vm = this;
        const { thead, tbody, progressBar } = vm.$refs;
        function setSameWidth() {
            const tbodyCells = tbody.$el.querySelectorAll('tbody tr:first-of-type td');
            const theadCells = thead.$el.querySelectorAll('thead tr th');
            if (tbodyCells) {
                for (let i = 0; i < tbodyCells.length; i++) {
                    let width = parseFloat(window.getComputedStyle(theadCells[i]).maxWidth);
                    if (width > 200)
                        width = 200;
                    theadCells[i].setAttribute('width', width);
                    tbodyCells[i].setAttribute('width', width);
                    tbodyCells[i].style.width = width + 'px';
                    tbodyCells[i].style.maxWidth = width + 'px';
                    tbodyCells[i].style.minWidth = width + 'px';
                }
            }
        }
        if (window.innerWidth > 767) {
            setSameWidth();
            const tbodyObserver = new MutationObserver(setSameWidth);
            tbodyObserver.observe(thead.$el, {
                childList: true,
                subtree: true,
                characterData: true
            });
            progressBar.$el.style.setProperty('--bgsx', progressBar.$el.clientWidth + 'px');
            window.addEventListener('resize', () => {
                progressBar.$el.style.setProperty('--bgsx', progressBar.$el.clientWidth + 'px');
            });
        }
        vm.ww = window.innerWidth;
        window.addEventListener('resize', () => {
            vm.ww = window.innerWidth;
        });
    },
    beforeCreate() {
        const parsedHeads = localStorage.getItem('mainPagePositionsHeaders');
        if (parsedHeads)
            tableHeadItems = JSON.parse(parsedHeads);
    },
    components: {
        draggable,
        Swiper,
        swiperSlide,
        mobPositionsTableDetailItem
    },
    mixins: [selectHandlersMixin]
});
